import { computed, Injectable, signal } from '@angular/core';
import { DomainState } from '@common/types';

@Injectable({ providedIn: 'root' })
export class DomainStateService {
  private readonly state = signal<DomainState>({
    domain: null,
    domainStatistic: null,
    domainServicesState: null
  });

  public readonly domain = computed(() => this.state().domain);
  public readonly domainStatistic = computed(() => this.state().domainStatistic);
  public readonly domainServicesState = computed(() => this.state().domainServicesState);

  patch(partial: Partial<DomainState>): void {
    this.state.update((state) => ({ ...state, ...partial }));
  }

  patchField<K extends keyof DomainState>(key: K, value: DomainState[K]): void {
    this.state.update((state) => ({ ...state, [key]: value }));
  }

  resetCache(): void {
    this.patch({
      domain: null,
      domainStatistic: null,
      domainServicesState: null
    });
  }
}
